import { FC } from "react";

export type AlertProps = {
  type: "success" | "danger" | "warning" | "info";
  message: string;
  onClose?: () => void;
};

const alertClasses: Record<AlertProps["type"], string> = {
  success: "alert-success",
  danger: "alert-danger",
  warning: "alert-warning",
  info: "alert-info",
};

const Alert: FC<AlertProps> = ({ message, type, onClose }) => (
  <div
    className={`alert ${alertClasses[type]} d-flex align-items-start justify-content-between gap-3 mb-0`}
    role="alert"
  >
    <span>{message}</span>
    {onClose ? (
      <button
        type="button"
        className="btn-close"
        aria-label="Luk"
        onClick={onClose}
      />
    ) : null}
  </div>
);

export default Alert;
